import React from 'react';
import styled from 'styled-components';

import Logo from '../images/maxus_logo.png';

const MaxusHeader = () => {
  return (
    <Header>
      <LogoImg src={Logo} alt='Maxus' />
    </Header>
  );
};

export default MaxusHeader;

const Header = styled.header`
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding: 3rem 5rem;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background-color: #2c387e;
`;

const LogoImg = styled.img`
  max-height: 70px;
`;
